<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h3>{{ $t("SalonProvider.salonDataShow") }}</h3>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="getDataToShow">
        <div class="row">
          <h4>
            {{ $t("SalonProvider.providerData") }}
          </h4>
          <!-- Start:: Phone Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.phone')"
            v-model.trim="data.phone"
            disabled
          />
          <!-- Start:: Bank Name Input -->
          <base-input
            v-if="data.bankName"
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.bankName')"
            v-model.trim="data.bankName"
            disabled
          />
          <!-- Start:: iBan Input -->
          <base-input
            v-if="data.iBan"
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.iban')"
            v-model.trim="data.iBan"
            disabled
          />
          <hr />

          <h4>
            {{ $t("SalonProvider.salonData") }}
          </h4>

          <!-- Start:: Logo Image -->
          <div class="table_image_wrapper m-auto">
            <base-image-upload-input
              col="12"
              identifier="image"
              :preSelectedImage="data.logo.path"
              :placeholder="$t('SalonProvider.salonLogo')"
              disabled
            />
            <!-- <button class="my-1" @click="showImageModal(data.logo.path)">
              <img class="rounded" :src="data.logo.path" width="130" height="140" />
            </button> -->
          </div>
          <!-- End:: Item Image -->
          <!-- Start:: laundry Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonNameAr')"
            v-model.trim="data.salonNameAr"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonNameEn')"
            v-model.trim="data.salonNameEn"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonPhone')"
            v-model.trim="data.salonPhone"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonEmail')"
            v-model.trim="data.salonEmail"
            disabled
          />
          <!-- Start:: Item Image -->
          <div class="table_image_wrapper m-auto">
            <base-image-upload-input
              col="12"
              identifier="image"
              :preSelectedImage="data.commercialRegister"
              :placeholder="$t('SalonProvider.salonDocument')"
              disabled
            />
          </div>
          <!-- End:: Item Image -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonDescAr')"
            v-model.trim="data.salonDescAr"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonDescEn')"
            v-model.trim="data.salonDescEn"
            disabled
          />
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonType')"
            v-model.trim="whatType.name"
            disabled
          />  -->
          <base-select-input
            class="placeholder_input"
            col="6"
            v-if="data.subBranch?.id"
            :optionsList="salons"
            :placeholder="$t('SalonProvider.mainSalonName')"
            v-model="data.subBranch"
            disabled
          />
          <!-- Start:: Categories -->
          <h4 v-if="data.categories.length > 0">
            {{ $t("SalonProvider.salonCat") }}
          </h4>
          <div class="category_wrapper mb-3 row" v-if="data.categories">
            <span
              v-for="cat in data.categories"
              v-if="cat"
              class="col-2 mx-2 rounded mb-3"
              :alt="$t('TABLES.Providers.laundryImage')"
              >{{ cat.name }}</span
            >
          </div>
          <!-- End:: Categories -->

          <hr />
          <h4>
            {{ $t("SalonProvider.salonAddress") }}
          </h4>
          <!-- Start:: Region Input -->
          <base-select-input
            class="placeholder_input"
            col="4"
            :optionsList="regions"
            :placeholder="$t('SalonProvider.salonRegion')"
            v-model="data.region"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('SalonProvider.city')"
            v-model.trim="data.city"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('SalonProvider.neighborhood')"
            v-model.trim="data.neighborhood"
            disabled
          />

          <!-- Start:: Address Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('SalonProvider.address')"
            v-model.trim="data.address"
            disabled
          />

          <!-- Start:: Map Address Input -->
          <div class="map_wrapper">
            <MapComponent
              v-if="data.lat && data.lng"
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
            />
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- ======================== Start:: Dialogs ======================== -->
    <template>
      <!-- Start:: Image Modal -->
      <image-modal
        v-if="dialogImage"
        :modalIsOpen="dialogImage"
        :modalImage="modalImage"
        :type="selectedItemType"
        @toggleModal="dialogImage = !dialogImage"
      />
      <!-- End:: Image Modal -->
    </template>
    <!-- ======================== End:: Dialogs ======================== -->
  </div>
</template>

<script>
import MapComponent from "@/components/general/MapComponent.vue";
import ImageModal from "@/components/modals/ImageModal.vue";
export default {
  name: "ShowJoinProvider",
  components: {
    MapComponent,
    ImageModal,
  },
  computed: {
    types() {
      return [
        {
          id: 0,
          name: this.$t("SalonProvider.salon"),
          value: "salon",
        },
        {
          id: 1,
          name: this.$t("SalonProvider.freelance"),
          value: "freelancer",
        },
      ];
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        logo: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        phone: null,
        salonNameAr: null,
        salonNameEn: null,
        salonPhone: null,
        salonEmail: null,
        salonDescAr: null,
        salonDescEn: null,
        commercialRegister: null,
        categories: [],
        type: null,
        subBranch: null,
        region: null,
        city: null,
        neighborhood: null,
        address: null,
        lat: null,
        lng: null,
        bankName: null,
        iBan: null,
      },
      regions: [],
      salons: [],
      whatType: { name: null },
      // End:: Data Collection To Send
      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemType: null,
      modalImage: null,
    };
  },
  methods: {
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
        });
        console.log("regions", res);

        this.regions = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Salons To Show
    async getSalons() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `salons?ignorePermissionCheck=1`,
        });
        // Start:: Set Data
        const salonsData = res.data.data.data;
        this.salons = salonsData;
      } catch (error) {
        console.log(error);
      }
    },
    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemType = "image";
      this.modalImage = item;
    },

    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });

        console.log("bank", res.data.data.data);

        // Start:: Set Data
        const providerData = res.data.data.data;
        this.data.phone = providerData.mobile;
        this.data.logo.path = providerData.salon.logo;
        this.data.salonNameAr = providerData.salon.name_ar;
        this.data.salonNameEn = providerData.salon.name_en;
        this.data.salonPhone = providerData.salon.mobile;
        this.data.salonEmail = providerData.email;
        this.data.salonDescAr = providerData.salon.description_ar;
        this.data.salonDescEn = providerData.salon.description_en;
        this.data.type = providerData.salon.type;
        this.data.subBranch = providerData.salon.main_branch;
        this.data.commercialRegister = providerData.salon.document;
        this.data.categories = providerData.salon.categories;

        const locationData = providerData.location || {};
        const neighborhoodData = locationData.neighborhood || null;
        const cityData = neighborhoodData?.city || null;
        const regionData = cityData?.region || providerData.region || null;

        this.data.region = regionData;
        this.data.city = cityData?.name || null;
        this.data.neighborhood = neighborhoodData?.name || null;
        this.data.address = locationData.address;
        this.data.lat = locationData.lat;
        this.data.lng = locationData.long;
        this.data.bankName = providerData.user_info.bank.name;
        this.data.iBan = providerData.user_info.iban;

        // // End:: Set Data

        if (this.data.type === "salon") {
          this.whatType = this.types[0];
        } else {
          this.whatType = this.types[1];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getSalons();
    this.getDataToShow();
    this.getRegions();
    // End:: Fire Methods
  },
};
</script>
<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}

.table_image_wrapper {
  margin-bottom: 25px;
}

.category_wrapper > span {
  background: #b67071;
  text-align: center;
  font-size: medium;
  color: white;
}
</style>
